import React, { useState } from 'react';
import { useStore } from '../../store/useStore';
import { CheckCircle2, AlertCircle, Clock, ChevronDown, Check } from 'lucide-react';
export function Orders() {
  const {
    orders,
    products,
    markOrderPickedUp,
    reportOrderChange,
    posConnected
  } = useStore();
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
  const getProduct = (id: string) => products.find(p => p.id === id);
  return <div className="max-w-5xl mx-auto space-y-6" data-id="element-122">
      <div className="flex justify-between items-end" data-id="element-123">
        <div data-id="element-124">
          <h1 className="text-3xl font-bold text-[#252935] mb-2" data-id="element-125">
            Orders & Pickups
          </h1>
          <p className="text-[#60646F]" data-id="element-126">
            Confirm pickups to maintain your accuracy score.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-[rgba(37,41,53,0.12)] overflow-hidden" data-id="element-127">
        <div className="p-4 border-b border-[rgba(37,41,53,0.12)] bg-gray-50 flex items-center justify-between" data-id="element-128">
          <h2 className="font-bold text-[#252935]" data-id="element-129">Today's Reserves</h2>
          {posConnected && <div className="flex items-center gap-1.5 text-sm text-[#007E7A] bg-[#E9FAF8] px-3 py-1 rounded-full" data-id="element-130">
              <CheckCircle2 className="w-4 h-4" data-id="element-131" />
              Auto-confirming via POS
            </div>}
        </div>

        <div className="divide-y divide-[rgba(37,41,53,0.12)]" data-id="element-132">
          {orders.map(order => {
          const product = getProduct(order.productId);
          if (!product) return null;
          return <div key={order.id} className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-133">
                <div className="flex items-center gap-6" data-id="element-134">
                  <div className="w-12 h-12 rounded-full bg-[#F4F5F6] flex items-center justify-center text-lg font-bold text-[#60646F]" data-id="element-135">
                    {order.shopperName.charAt(0)}
                  </div>
                  <div data-id="element-136">
                    <h3 className="font-bold text-[#252935] text-lg" data-id="element-137">
                      {order.shopperName}
                    </h3>
                    <p className="text-[#60646F] flex items-center gap-2" data-id="element-138">
                      <Clock className="w-4 h-4" data-id="element-139" /> Reserved for{' '}
                      {order.reservedTime}
                    </p>
                  </div>
                  <div className="w-px h-12 bg-[rgba(37,41,53,0.12)] mx-4" data-id="element-140"></div>
                  <div data-id="element-141">
                    <div className="font-bold text-[#252935]" data-id="element-142">
                      {product.name}
                    </div>
                    <div className="text-sm text-[#60646F]" data-id="element-143">
                      ${order.reservedPrice} reserved price
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-144">
                  {order.status === 'Picked up' && <div className="flex items-center gap-1.5 text-[#007E7A] font-bold" data-id="element-145">
                      <CheckCircle2 className="w-5 h-5" data-id="element-146" />
                      Picked up
                    </div>}
                  {order.status === 'Flagged' && <div className="flex items-center gap-1.5 text-[#C98A2E] font-bold" data-id="element-147">
                      <AlertCircle className="w-5 h-5" data-id="element-148" />
                      Flagged
                    </div>}
                  {order.status === 'Reserved' && <div className="flex items-center gap-2" data-id="element-149">
                      <button onClick={() => markOrderPickedUp(order.id)} className="px-5 py-2.5 bg-[#00CDBE] text-white rounded-full text-sm font-bold hover:bg-[#00B8AA] flex items-center gap-2" data-id="element-150">
                        <Check className="w-4 h-4" data-id="element-151" />
                        Mark picked up
                      </button>

                      <div className="relative" data-id="element-152">
                        <button onClick={() => setOpenDropdownId(openDropdownId === order.id ? null : order.id)} className="px-4 py-2.5 bg-white border border-[rgba(37,41,53,0.12)] rounded-full text-sm font-bold text-[#252935] hover:bg-gray-50 flex items-center gap-2" data-id="element-153">
                          Report change
                          <ChevronDown className="w-4 h-4" data-id="element-154" />
                        </button>

                        {openDropdownId === order.id && <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-[rgba(37,41,53,0.12)] py-1 z-20" data-id="element-155">
                            {['Out of stock', 'Price changed', 'Substituted'].map(reason => <button key={reason} onClick={() => {
                      reportOrderChange(order.id, reason);
                      setOpenDropdownId(null);
                    }} className="w-full text-left px-4 py-2 text-sm text-[#252935] hover:bg-gray-50" data-id="element-156">
                                {reason}
                              </button>)}
                          </div>}
                      </div>
                    </div>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </div>;
}